module.exports = __webpack_public_path__ + "static/assets/8362368cc4c03c991de606649ae8fccd.svg";